import React, { useEffect, useRef } from 'react';
import $ from 'jquery';
import Reactor from 'javascripts/reactive_rails';

interface ReactiveContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  reactiveUrl: string;
  reactivePath?: string | null;
  isShared?: boolean;
  children?: React.ReactNode;
}

export default function ReactiveContainer({
  reactiveUrl,
  reactivePath = null,
  isShared = false,
  ...props
}: ReactiveContainerProps): JSX.Element {
  const container = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (container.current) {
      Reactor.updateReactiveElement($(container.current), undefined, {
        isShared,
      });
    }
  }, [isShared, reactiveUrl]);

  return (
    <div
      {...props}
      ref={container}
      data-reactive-url={reactiveUrl}
      data-reactive-path={reactivePath}
    />
  );
}
